import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import type { TollReportDetails } from '../../../../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'
import { formatNumber } from '../../../utils/formatNumber'

type DataProps = {
  options: { year: string; month: string }
}
export default function tollReportDetailsColumns({ options }: DataProps) {
  const columnHelper = createColumnHelper<TollReportDetails>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      enableSorting: false,
      header: 'Reg.nr.',
      cell: ({ row, getValue }) => (
        <NavLink
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/toll/${options.year}-${options.month}/${row.original.accountNo}?regNo=${getValue()}`}
        >
          {getValue()}
        </NavLink>
      ),
    }),
    columnHelper.accessor('vehicleID', {
      id: 'vehicleID',
      enableSorting: false,
      header: 'Kjøretøy-ID',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('invoiceGroupingDescription', {
      id: 'invoiceGroupingDescription',
      header: 'Fakturagruppe',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('carDescription', {
      id: 'carDescription',
      enableSorting: false,
      header: 'Objekt',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('driverName', {
      id: 'driverName',
      enableSorting: false,
      meta: { alignmentType: 'string' },
      header: 'Sjåfør',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      meta: {
        mobileFooterLabel: 'Sum beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountIncVAT') as number) || 0), 0)
        return formatCurrency(total)
      },

      cell: (row) => formatCurrency(row.getValue()) || '',
    }),
    columnHelper.accessor('antallPasseringer', {
      id: 'antallPasseringer',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Totalt antall passeringer',
        alignmentType: 'right',
      },
      header: 'Antall passeringer',
      cell: (row) => formatNumber(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('antallPasseringer') as number) || 0), 0)
        return formatNumber(total)
      },
    }),
  ]
}
